module.exports = __webpack_public_path__ + "static/media/about.e7db1d19.jpg";